// Utility to compute assessment status counts
export function isAssessmentCompleted(a) {
  if (!a || !Array.isArray(a.questionnaires) || a.questionnaires.length === 0) return false;
  return a.questionnaires.every(q => (q.totalQuestion ?? 0) > 0 && (q.answered ?? 0) >= (q.totalQuestion ?? 0));
}


export function isAssessmentProcessing(a) {
  if (!a || !Array.isArray(a.questionnaires) || a.questionnaires.length === 0) return false;
  const allComplete = isAssessmentCompleted(a);
  if (allComplete) return false;
  return a.questionnaires.some(q => (q.answered ?? 0) > 0);
}

export function getCountsFromAssessments(arr = []) {
  const total = Array.isArray(arr) ? arr.length : 0;
  const completed = Array.isArray(arr)
    ? arr.filter(isAssessmentCompleted).length
    : 0;
  const processing = Array.isArray(arr)
    ? arr.filter(isAssessmentProcessing).length
    : 0;
  const pending = Math.max(0, total - completed - processing);
  return { total, completed, processing, pending };
}

export default { isAssessmentCompleted, isAssessmentProcessing, getCountsFromAssessments };
